import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import download from 'downloadjs';
import Multiselect from 'vue-multiselect'

import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import { data } from 'jquery';

export default {
	name: 'restriction-hub-detail',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		download,
		Multiselect
	},
	data: function() {
		return {
			isLoadingSearch: false,
			isZoneLoading:'',
			isCityLoading:'',
			isFacilityNameLoading:'',
			facilityList: [
				{
				value: '1',
				text: "SVC"
			   },
		       {
				value : '2',
				text: 'RSC'
			   },
			   {
				value : '3',
				text: 'HUB'

			   }
		    ],
			facilityListyObjData: {
				value: "",
				text: ""
			}
			,
			facilityListid:"",

			facilityNameList:[],

			facilityNameListyObjData: {
				value: "",
				text: "",
				text1: ""
			},

			facilityNameListid:"",

			cityList:[],
			cityObjData:{
				value: "",
				text: ""
			},

			cityId:"",

			zoneList:[],

			zoneObjData:{
				value: "",
				text: ""
			},

			zoneid:"",
			MasterHubInfraDetailsData: {
				id: 0,
				facilityType: "",
				facilityNameListid:"",
				facilityName: "",
				city :"",
				zone : "",

			},
			stickerPrintingStatus:false,
			himid :'',
			statusUpdateid:'',
			disabled: false,
			showTable :false,
			pageno: 0,
			pageCount: 0,
			totalRows: 0,
			limit: 10,
			showModal: false,
			hubcityid:'',
			isLoadingSave:false,
			hubnameerror:"",
			rtostickerPrintingStatus:false,
            hubid:0,
			csvData:[],
			facilityNameListArr:[]
		}
	},
	created: function() {},
	computed: {},
	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;

		this.getCityList();
		this.getAllHubs();
		this.getHubZoneData();
	},
	methods: {

		   selectedFacilityType(facilityData){
			this.facilityListyObjData = facilityData;
            this.facilityListid = facilityData.text;
           },

		  selectedFacilityName(facilityNameData){
			this.facilityNameListyObjData = facilityNameData;
         this.facilityNameListid = facilityNameData.value;

      this.hubid = 0
			this.hubid = facilityNameData.value
			this.zoneid = facilityNameData.text1
			this.getCityidForHub(facilityNameData.value);
		   },

		   statusUpdate(data) {
				this.himd = data.himd;
				
				if (data.StickerPrintFlag) {
					this.stickerPrintingStatus = true
				  } else {
					this.stickerPrintingStatus = false;
				  }
				this.updatePrintRestriction(data);
			},

			statusRtoUpdate(data){
				this.himd = data.himd;
				if (data.RtoStickerPrintFlag) {
					this.rtostickerPrintingStatus = true
				  } else {
					this.rtostickerPrintingStatus = false;
				  }
				this.updateRtoPrintRestriction(data);

			},


			selectedCity(cityData) {
				this.cityObjData = cityData,
				this.cityId = cityData.value
		  	},

			selectedZone(zoneData) {
				this.zoneObjData = zoneData,
				this.zoneid = zoneData.value
		  	},

			getCityList() {
				var i = 0;
				this.resultCount = 0;
				this.isCityLoading = 'Loading City...';
				this.input = ({})
				axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'allcity/get',
					'data': this.input,
					headers: {
				  	'authorization': 'authkey xB84JJ89Hd25',
				}
			  	})
			  	.then(result => {
				if (result.data.ResultCode == 100) {
				this.isCityLoading = '';
				let citylist = result.data.ResponseData;
				for (i = 0; i < citylist.length; i++) {
				  this.cityList.push({
					value: citylist[i].cityid,
					text: citylist[i].cityname
				  })
				}
				}else{
					this.isCityLoading = '';
                	this.$alertify.error(result.data.ReturnMessage);
			 	}
			}, error => {
				this.isCityLoading = '';
				console.error(error)
			})
		    },
		    getAllHubs() {
				var i = 0;
				this.input = ({})
				this.isFacilityNameLoading = 'Loading Facility Name...';
				axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
					this.isFacilityNameLoading = '';
					const facilityNamelist = result.data.ResponseData
					for (i = 0; i < facilityNamelist.length; i++) {
						this.facilityNameList.push({
							value: facilityNamelist[i].HubID,
							text: facilityNamelist[i].HubName + ' (' + facilityNamelist[i].HubID + ')',
							text1: facilityNamelist[i].HubZoneId
						})
					}
				}else{
					this.isFacilityNameLoading = '';
					this.$alertify.error(result.data.ReturnMessage);
				}
				}, error => {
					this.isFacilityNameLoading = '';
					console.error(error)
				})

			},

			getCityidForHub(hubid) {
			this.hubcityid='';
			this.input = ({
				"id" : hubid
			})
			this.isFacilityNameLoading = 'Loading ...';
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				this.isFacilityNameLoading = '';
					if (result.data.ResultCode == 100) {
        	this.hubcityid= result.data.ResponseData[0].CityId;
				} else{
					this.$alertify.error(result.data.ReturnMessage)
				}
        },error => {
					this.isFacilityNameLoading = '';
				console.error(error)
			})
		},

			onSubmit: function() {
			this.$validator.validateAll('form-1')
				.then((result) => {
					this.pageno=0;
					if (!result) {
						return false;
					} else {
						this.loadMasterHubInfraDetails();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
			},

			getHubZoneData() {
				this.isZoneLoading = 'Loading Hub Zone...';
				this.input = ({})
				axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
				  		'authorization': 'authkey xB84JJ89Hd25',
					}
			  	})
			  	.then(result => {
					if (result.data.ResultCode == 100) {
				  		this.isZoneLoading = '';
				  		let listHubZoneData = result.data.ResponseData;
				  		for (let i = 0; i < listHubZoneData.length; i++) {
							this.zoneList.push({
					  		value: listHubZoneData[i].hubzoneid,
					  		text: listHubZoneData[i].hubzonename
						})
				  	}
					}
					else{
						this.isZoneLoading = '';
						this.$alertify.error(result.data.ReturnMessage);
					}

			  	}, error => {
					this.isZoneLoading = '';
					console.error(error)
			  	})
		  	},

			loadMasterHubInfraDetails() {
				this.isLoadingSearch = true
				this.input = {};
				this.totalRows = 0;
				this.resultCount = 0;

				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops  + 'fetchFacilityDetails?offset=' + this.pageno + '&limit=' + this.limit+ (this.facilityListid? "&facilitytype=" + this.facilityListid : '' ) + (this.facilityNameListid? "&facilityid=" + this.facilityNameListid: '' ) +(this.zoneid? "&facilityzoneid=" + this.zoneid: '')+(this.cityId? "&cityid=" + this.cityId : ''),
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}

				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData) {
							this.isLoadingSearch = false;
							this.showTable = true;
							this.totalRows = result.data.TotalCount;
							this.MasterHubInfraDetailsData = response.ResponseData;
							if (this.totalRows < this.limit) {
								this.pageCount = 1
							  } else {
								this.pageCount = Math.ceil(this.totalRows / this.limit);
							  }
						}
					} else {
						this.MasterHubInfraDetailsData = {};
						this.isLoadingSearch = false;
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch = false;
					console.error(error)
				})
			},

			updatePrintRestriction(data) {
			  this.input = ({
                himd: this.himd,
				hubid:data.hubid,
				status:this.stickerPrintingStatus,
				modifiedby: this.useremail,
				facilityType: data.FacilityType,
				facilityName: data.FacilityName,
				city: data.City,
				zoneName: data.ZoneName,
				isActive: data.isActive,
				isrtorestrictprinting: data.RtoStickerPrintFlag,
			  })

			  axios({
				  method: 'PUT',
				  'url': apiUrl.api_url_hubops + 'updateStickerPrintingRestrictionStatus',
				  'data': this.input,
				  headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				  }
				})
				.then(result => {
				  if (result.data.ResultCode == 100) {
					this.$alertify.success('Dto Sticker Printing Status Updated Successfully', "", "success")
					this.loadMasterHubInfraDetails();

				  }else{
					this.$alertify(result.data.ReturnMessage, "", "error");
				  }
				}, error => {
				  console.error(error)
				})
			},

			updateRtoPrintRestriction(data) {
				this.input = ({
				  himd: this.himd,
				  hubid:data.hubid,
				  status:this.rtostickerPrintingStatus,
				  modifiedby: this.useremail,
				  facilityType: data.FacilityType,
				  facilityName: data.FacilityName,
				  city: data.City,
				  zoneName: data.ZoneName,
				  isActive: data.isActive,
				  isrestrictprinting: data.StickerPrintFlag,
				})
  
				axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'updateRtoStickerPrintingRestrictionStatus',
					'data': this.input,
					headers: {
					  'authorization': 'authkey xB84JJ89Hd25',
					}
				  })
				  .then(result => {
					if (result.data.ResultCode == 100) {
					  this.$alertify.success('Rto Sticker Printing Status Updated Successfully', "", "success")
					  this.loadMasterHubInfraDetails();
  
					}else{
					  this.$alertify(result.data.ReturnMessage, "", "error");
					}
				  }, error => {
					console.error(error)
				  })
			  },

			insertPrintRestriction() {
				if (this.hubid == 0) {
					this.hubnameerror = ' Facility name field is required.'
					return false
				} else {
					this.hubnameerror = ''
				}
				this.isLoadingSave = true,
				this.input = ({
					hubid: this.hubid,
		      cityid: this.hubcityid,
		      zoneid: this.zoneid,
		      isactive: true,
		      isrestrictprinting: true,
			  isrtorestrictprinting:true,
		      createdby: this.useremail
				})
				axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'insertStickerPrintingRestriction',
					'data': this.input,
					headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoadingSave = false
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
					}else{
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoadingSave = false
					console.error(error)
				})
			},
			exportData(){
				this.isLoadingSearch = true
				this.input = {};
				this.totalRows = 0;
				this.resultCount = 0;

				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops  + 'fetchFacilityDetailsExport?' +(this.facilityListid?"facilitytype=" + this.facilityListid :'')  + (this.facilityNameListid? "&facilityid=" + this.facilityNameListid: '' ) +(this.zoneid? "&facilityzoneid=" + this.zoneid: '')+(this.cityId? "&cityid=" + this.cityId : ''),
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}

				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData) {
							this.isLoadingSearch = false;
							this.csvData = result.data.ResponseData.map((e) => {
                return {
                  'himd': e.himd,
				  'FacilityId':e.FacilityId,
                  'FacilityName': e.FacilityName,
                  'FacilityType': e.FacilityType,
                  'City': e.City,
                  'ZoneName': e.ZoneName,
                  'DtoStickerPrintFlag': e.StickerPrintFlag,
				  'RtoStickerPrintFlag': e.RtoStickerPrintFlag,
                  'createdby': e.createdby,
                  'createddate': e.createddate,
				  'lastmodifiedby': e.lastmodifiedby,
                  'lastmodifieddate': e.lastmodifieddate,
                }
              });
              this.csvFields = {
                'himd': 'HIMD',
				'FacilityId':'FacilityId',
                'FacilityName': 'FacilityName',
								'FacilityType': 'FacilityType',
								'City': 'City',
								'ZoneName': 'ZoneName',
								'DtoStickerPrintFlag': 'DtoStickerPrintFlag',
								'RtoStickerPrintFlag': 'RtoStickerPrintFlag',
								'createdby': 'createdby',
								'createddate': 'CreatedDate',
								'lastmodifiedby': 'LastModifiedBy',
								'lastmodifieddate': 'LastModifieDate',
              }
              this.jsonToCSV('Report_', this.csvData, this.csvFields);
					} }else {
						this.isLoadingSearch = false;
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoadingSearch = false;
					console.error(error)
				})
			},
			resetForm() {
				this.zoneObjData = {
					value: "",
					text: ""
				},
			this.zoneid ="",

			this.facilityNameListyObjData = {
				value: "",
				text: "",
				text1:"",
			},

			this.facilityNameListid="",

			this.facilityListyObjData= {
				value: "",
				text: ""
			}
			,
			this.facilityListid="",

			this.cityObjData={
				value: "",
				text: ""
			},

			this.cityId="",

			this.MasterHubInfraDetailsData = {};
			this.isLoadingSearch = false;
			this.$validator.reset();
			this.errors.clear();

			this.pageno = 0;
			this.pageCount = 0;
			this.limit= 10;
			this.totalRows = 0;
			this.resetFlt = 0;
            this.hubid = 0;
			this.hubnameerror = '';
			this.facilityNameListArr=[]
			
		    },

			getPaginationData(pageNum) {
				this.pageno = (pageNum - 1)
				this.loadMasterHubInfraDetails()
		  	},

				closeModal() {
		      this.showModal = false;
		      $(document.body).removeClass("modal-open");
		      $(".modal-backdrop").remove();
		    },
				jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
		      var csvData = ''
		      //Header
		      if (this.title != null) {
		        csvData += this.parseExtraData(this.title, '${data}\r\n')
		      }
		      //Fields
		      for (let key in data[0]) {
		        if (skipFilter.indexOf(key) == -1)
		          csvData += csvfield[key] + ','
		      }
		      csvData = csvData.slice(0, csvData.length - 1)
		      csvData += '\r\n'
		      //Data
		      data.map(function (item) {
		        for (let key in item) {
		          if (skipFilter.indexOf(key) == -1) {
		            var escapedCSV = item[key] + '' // cast Numbers to string
		            if (escapedCSV.match(/[,"\n]/)) {
		              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
		            }
		            if (escapedCSV == 'null')
		              csvData += ',';
		            else {
		              if (dateFilder.indexOf(key) != -1)
		                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
		              else
		                csvData += escapedCSV + ','
		            }
		          }
		        }
		        csvData = csvData.slice(0, csvData.length - 1)
		        csvData += '\r\n'
		      })
		      //Footer
		      if (this.footer != null) {
		        csvData += this.parseExtraData(this.footer, '${data}\r\n')
		      }
		      filename += moment().format('DD-MM-YYYY') + '.csv';
		      return this.export(csvData, filename, "application/csv");
		      return csvData
		    },
		    export(data, filename, mime) {
		      let blob = this.base64ToBlob(data, mime)
		      download(blob, filename, mime)
		      this.$alertify.success("Successful")
		    },
		    base64ToBlob(data, mime) {
		      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
		      let bstr = atob(base64)
		      let n = bstr.length
		      let u8arr = new Uint8ClampedArray(n)
		      while (n--) {
		        u8arr[n] = bstr.charCodeAt(n)
		      }
		      return new Blob([u8arr], {
		        type: mime
		      })
		    }
	}

}



// WEBPACK FOOTER //
// ./src/views/components/ThermalPrinterAllocation/MasterHubInfraDetails/MasterHubInfraDetails.js